import Swal from 'sweetalert2';

export function isUserDemoBypass(user) {
  if (!user || typeof user !== 'object') return false;
  const src = String(user.source ?? '').trim().toUpperCase();
  const role = String(user.role ?? '').trim().toUpperCase();
  if (src === 'DEMO') return true;
  if (role === 'DEMOBYPASS') return true;
  const sid = String(user.sessionId ?? '').trim().toLowerCase();
  if (sid === 'demobypass' || sid.startsWith('demo')) return true;
  return false;
}

export function demoGatePopupAndRedirect() {
  window.setTimeout(() => {
    Swal.fire({
      icon: 'info',
      text: 'Thank you for playing. Subscribe to any PLAN to play with your peers.',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      window.location.href = (process.env.REACT_APP_BASE_URL || '') + '/plans';
    });
  }, 400);
}

